import React from 'react'
import "./retail.scss"
import FinancialChains from './sections/financialChains'
import Letsgo from "../connectors/letsgo"
import RealTimeProcesses from './sections/realTimeProcesses'
import FinancialsOperationalList from './sections/financialsOperationalList'



function FinancialsOperational() {
  return (
    <div className='container-retail'>
        <div className='section-b2c-profits'>
          <FinancialChains />
        </div>
        <div className="section-numerous-processes">
          <RealTimeProcesses />
        </div>
        <div className="section-product-performance-list">
          <FinancialsOperationalList />
        </div>
        <div className="section-lets-go">
          <Letsgo />
        </div>
    </div>
  )
}

export default FinancialsOperational